module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Timeline Page\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-674e326e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ui-elements/Timeline.vue
// module id = 524
// module chunks = 1